<template>
  <div class="admin-login-layout">
    <div class="login-content">
      <div class="login-type--img">
        <img src="../../assets/img/Republic_of_China_Police_Station_Logo.svg" alt="">
        <!-- <img src="/static/svg/backend-settings.svg" alt=""> -->
        <h4><kbd>彰化台61科技執法後端管理系統</kbd></h4>
      </div>
      <form class="login-method-wrap"
        ref="password"
        @submit.prevent="login">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">帳號</span>
          </div>
          <input class="form-control" type="text" id="username" v-model="username">
        </div>
        <hr>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">密碼</span>
          </div>
          <input type="password" class="form-control" id="password" v-model="password">
        </div>
        <hr>
        <vue-recaptcha
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          size="invisible"
          sitekey="6Le-LLwZAAAAAAIgW13yIFTeYzeX36TICYZXRc93">
        </vue-recaptcha>
        <button class="btn btn-warning btn-lg" type="submit">
          登入
        </button>
      </form>
    </div>
  </div>
</template>


<script>
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios';
export default {
  name: 'AdminLogin',
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      username: '',
      password: '',
    };
  },
  created() {
    console.log('jquery:',jQuery().jquery);
  },
  methods: {
    onCaptchaVerified: function(recaptchaToken) {
      this.$store.dispatch('loginAndGetUser', {
        username: this.username,
        password: this.password,
        recaptchaToken: recaptchaToken,
      })
      .then(() => {
        if (this.$store.state.user.user.is_admin === false) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '您沒有權限登入後台，請聯絡管理員',
          });
        } else {
          this.$router.push({ name: 'Admin' });
        }
      })
      .catch((err) => {
        console.log(err.response);
        if (err.response !== undefined) {
          if (err.response.status==401){
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '疑似為機器人，禁止登入',
            });
          }
          else {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '帳號或密碼錯誤',
            });
          }
        } else {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '伺服器連線失敗',
          });
        }
      });       
    },
    onCaptchaExpired: function() {
      this.$refs.recaptcha.reset();
    },
    login() {
      this.$refs.recaptcha.execute();
    },
  },
};
</script>

<style lang="sass" scoped>
.admin-login-layout
  height: 100vh
  width: 100wh
  display: flex
  .login-content
    margin: auto
    //background-color: #37474F
    padding: 20px 0
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border: 5px solid rgba(0,0,0,0.4)
    width: 500px
    border-radius: 10px
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);



.login-type--img
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 400px
  img
    width: 60%
  h4
    margin: 10px 0 20px 0

.login-method-wrap
  width: 80%
  height: 100%
  padding: 2%
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  button
    width: 100%
</style>




// WEBPACK FOOTER //
// AdminLogin.vue?5a29bd1e